import React from 'react';
import { motion } from 'framer-motion';
const projects = [{
  title: "Mike's Barber Shop",
  category: 'Barber / Grooming',
  image: 'https://cdn.magicpatterns.com/uploads/pG8VE3Kvv17fsSy925EZSd/Barber_Shop.png'
}, {
  title: 'Happy Smiles Pediatric Dentistry',
  category: 'Healthcare / Dental',
  image: 'https://cdn.magicpatterns.com/uploads/hj6EA9wCF3QhoMcUvAQHrM/Dental_Website.png'
}, {
  title: 'Afriel Massage',
  category: 'Spa / Wellness',
  image: 'https://cdn.magicpatterns.com/uploads/cTj1ghcLXmdvwoDGaGn9Cw/Massage.png'
}, {
  title: "Mike's Pro Detail",
  category: 'Auto Detailing',
  image: 'https://cdn.magicpatterns.com/uploads/kQdBxSjwFZRJMwCi79gbGo/Mikes_pro_detail.png'
}, {
  title: '101 Transportation Services',
  category: 'Luxury Transportation',
  image: 'https://cdn.magicpatterns.com/uploads/gny86ybuBHsRktfxpBipEv/101_Transport.png'
}, {
  title: 'U.S. Hanger Co.',
  category: 'Manufacturing / B2B',
  image: 'https://cdn.magicpatterns.com/uploads/6h4fQcKfY7bNaCsruMunUF/US_Hanger_Company.png'
}];
export function Portfolio() {
  return <section id="portfolio" className="py-24 bg-black border-y border-white/5" data-id="element-254">
      <div className="container mx-auto px-6 md:px-12" data-id="element-255">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-256">
          <div className="max-w-2xl" data-id="element-257">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-258">
              Recent <span className="text-gradient" data-id="element-259">Work</span>
            </h2>
            <p className="text-lg text-[#FFFFFF]" data-id="element-260">
              A selection of high-performing websites built to drive traffic,
              generate leads, and establish brand authority.
            </p>
          </div>
          <a href="#contact" className="hidden md:inline-flex px-6 py-3 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium transition-all" data-id="element-261">
            Start Your Project
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-262">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="rounded-2xl overflow-hidden bg-[#111118] border border-white/5" data-id="element-263">
              <img src={project.image} alt={project.title} className="w-full h-auto block" data-id="element-264" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}